import { Api } from '../api';
import { CentrifugoConfig } from './model';

export const centrifugoApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    getCentrifugoSubscription: builder.query<
      CentrifugoConfig,
      { sellerWorkspaceId: string }
    >({
      query(arg) {
        return {
          url: 'hub/communication-v2/api/centrifugo/token',
          method: 'GET',
          params: arg,
        };
      },
    }),
  }),
});

export const { useLazyGetCentrifugoSubscriptionQuery } = centrifugoApi;
